import { Helmet } from 'react-helmet';

export default function DynamicMeta({ title, description }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="og:description" content={description} />
    </Helmet>
  );
}
